import { kebabCase } from 'lodash';
import composeFieldName from './composeFieldName';
/*
 * Compose field value with multiple options
 */
const composeFieldOption = (value, facetId, legacyFacetQueryParameters, currentFacetKeys = []) => {
  const { data, label } = value;
  const { queryStringParamValue } = legacyFacetQueryParameters[label];
  const id = `${facetId}-${kebabCase(data)}`;

  const option = {
    id,
    label: label,
    value: queryStringParamValue,
    isDisabled: !currentFacetKeys.find((e) => e === label), // search currentFacetKeys for this facet name
  };

  return option;
};

/**
 * Search FB results query facets for a single facet based on name. Return array of facet names for comparison later.
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {any} facet
 * @param {any} resultFacets
 * @returns {any}
 */
const composeCurrentFacetKeys = (facet, resultFacets) => {
  let keys = [];
  const found = resultFacets.find((e) => {
    return e.name === facet.name;
  });

  if (found) {
    const { allValues } = found;
    if (allValues?.length) {
      keys = allValues.map((e) => e.label);
    }
  }
  return keys;
};

/*
 * Deserialise Funnelback facet category values to Formik values (FB16)
 */

const composeFieldValues = (allFacets, resultFacets, multiSelectFacetNames = [], facetExclusions = [], idPrefix = 'facet-field') => {
  if (!allFacets || !allFacets.length) {
    return null;
  }

  const facetFields = {};

  allFacets.forEach((facet, index) => {
    
    const { guessedDisplayType, name, customData, allValues } = facet;
    const legacyFacetQueryParameters = customData?.legacyFacetQueryParameters;

    // if this facet is not on the exlusion list
    if (Object.keys(legacyFacetQueryParameters).length && facetExclusions.indexOf(name) === -1) {

      const { queryStringParamName } = legacyFacetQueryParameters[Object.keys(legacyFacetQueryParameters)[0]];
      const fieldKey = composeFieldName(queryStringParamName);
      const currentFacetKeys = composeCurrentFacetKeys(facet, resultFacets);

      const id = `${idPrefix}${kebabCase(fieldKey)}`;

      // Assign default facet type
      let facetType = 'select';

      // Check if guessedDisplayType is set
      switch (guessedDisplayType) {
        case 'CHECKBOX':
          facetType = 'checkboxGroup';
          break;
        case 'DATE_RANGE':
          facetType = 'dateRange';
      }

      // Check if facets should be displayed as a multi select component
      if (multiSelectFacetNames.includes(facet.name.toLowerCase()) && facet.selectionType === 'MULTIPLE') {
        facetType = 'multiSelect';
      }

      const formattedField = {
        name: fieldKey,
        facetType,
        label: name,
        id,
        facetOrder: index,
        options: allValues.map((value) => composeFieldOption(value, id, legacyFacetQueryParameters, currentFacetKeys)),
      };
      facetFields[fieldKey] = formattedField;
    }
  });

  const fieldsConfig = {
    query: {
      name: 'query',
      type: 'text',
      label: 'Keywords',
      id: `${idPrefix}query`,
      placeholder: 'Search by keywords',
    },
    ...facetFields,
  };
  return fieldsConfig;
};

export default composeFieldValues;
